__turbopack_context__.v({
  "listItem": "ToolCard-module__jYqgSG__listItem",
  "metadataHeader": "ToolCard-module__jYqgSG__metadataHeader",
});
